import BadgeCustom from '@/components/elements/Badge';
import { azul, lightGray, oro, red, white } from '@/constants/Colors';
import { LoginDatos } from '@/objects/User';
import { esPremium } from '@/util/StringsUtil';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    datosUsuario: LoginDatos | null;
    setDatosUsuario: React.Dispatch<React.SetStateAction<LoginDatos | null | undefined>>;
}

const BadgesUser: React.FC<Props> = ({ datosUsuario, setDatosUsuario }) => {

    const { t } = useTranslation();

    const [premiumUser, setPremiumUser] = React.useState<boolean>(false);
    const [favoritosPlus, setFavoritosPlus] = React.useState<boolean>(false);
    const [destacarGratis, setDestacarGratis] = React.useState<boolean>(false);

    useEffect(() => {
        //alert(datosUsuario?.premium)
        if (datosUsuario) {
            setPremiumUser(esPremium(datosUsuario.premium));
            setFavoritosPlus(datosUsuario.conFavoritos == 1);
            setDestacarGratis(esPremium(datosUsuario.premium));
        }
    }, [datosUsuario]);

    const disabledColor = lightGray
    const premiumColor = oro
    const favoritosColor = red;
    const destacarColor = azul;

    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '5px', alignItems: "center" }}>
            <BadgeCustom texto={premiumUser ? t('common:caracteristicas.premium') : t('common:caracteristicas.no_premium')} color={white} backgroundColor={premiumUser ? premiumColor : disabledColor} />
            {/* <BadgeCustom texto={t('common:caracteristicas.favoritos_plus')} color={white} backgroundColor={favoritosPlus ? favoritosColor : disabledColor} /> */}
            <BadgeCustom texto={t('common:caracteristicas.destacar_gratis')} color={white} backgroundColor={destacarGratis ? destacarColor : disabledColor} />
        </div>
    );
}

export default BadgesUser;